import React from 'react';

const Title = () => {
    return (
        <div className="title">
            <h1>PictoGram</h1>
            
            <p>freezing your moment here</p>
        </div>
    )
}

export default Title;